<div class="content-actions">
    <div class="bandeau-actions">
        <div class="left-part">
            <ng-content select="[left-part]"></ng-content>
        </div>
        <div class="right-part">
            <ng-content select="[right-part]"></ng-content>
        </div>
    </div>
</div>
